module.exports = __webpack_public_path__ + "img/listing-dislike.c98be719.svg";